import React from 'react';

const DepositsSumPercentPerPlayer = () => {
    return (
        <div>

        </div>
    )
}

export default DepositsSumPercentPerPlayer;